export const METRICS_I18N_ENTRIES = {
  metrics_Data1: {
    es: '<p>Nuestra <span class="i18n-bold">tasa de\nacierto</span> es de un <span class="i18n-bold">97%</span>\nen España, Portugal,\nMéxico y Chile</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
  },
  metrics_Data2: {
    es: '<p>KILÓMETROS RECORRIDOS</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
  },
  metrics_Data3: {
    es: '<p>KILÓMETROS DETECTADOS</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
  },
  metrics_Data4: {
    es: '<p>VIDEOS ANALIZADOS (min)</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
  },
  metrics_Data5: {
    es: '<p>Saber más</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
  },
  metrics_Data6: {
    es: '<p><span>Selecciona</span> el país para ver nuestros servicios en él</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
  },
  metrics_Data7: {
    es: '<p>Arrastra el mapa para descubrir</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
  },
};
